var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1.28 1.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.2.15h-1A.07.07,0,0,1,.15.08.07.07,0,0,1,.22,0h1a.07.07,0,0,1,.08.08A.07.07,0,0,1,1.2.15Z",
    fill: "#2e2d2c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2,1.13a.07.07,0,0,1-.07-.07v-1A.07.07,0,0,1,1.2,0a.07.07,0,0,1,.08.08v1A.07.07,0,0,1,1.2,1.13Z",
    fill: "#2e2d2c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.08,1.28,0,1.26a.08.08,0,0,1,0-.11L.17,1a.08.08,0,0,1,.11.11l-.15.15Z",
    fill: "#2e2d2c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.43.92l0,0a.08.08,0,0,1,0-.11L1.15,0a.08.08,0,0,1,.11,0,.08.08,0,0,1,0,.11L.49.9Z",
    fill: "#2e2d2c"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkArrow);
export default __webpack_public_path__ + "static/media/link-arrow.a084e4275bacad1dd5f3ba1d642269bb.svg";
export { ForwardRef as ReactComponent };